// frontend/src/components/handbook/HandbookTOC.js
import React from "react";
import { CheckCircle2 } from "lucide-react";
import { getChapterProgress } from "../../utils/handbookProgress";

const slugifyTitle = (s) =>
  (s || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "") || "checkliste";

const HandbookTOC = ({ chapter }) => {
  if (!chapter || !Array.isArray(chapter.checklists)) return null;
  if (chapter.checklists.length < 3) return null;

  const handleClick = (e, anchorId) => {
    e.preventDefault();
    const el = document.getElementById(anchorId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <aside className="hidden xl:block w-56 flex-shrink-0">
      <div className="sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto pl-4 border-l border-gray-100">
        <div className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-3">
          Auf dieser Seite
        </div>
        <ul className="space-y-1">
          {chapter.checklists.map((cl, idx) => {
            const anchor = `cl-${slugifyTitle(cl.title || "")}`;
            let done = 0;
            let total = cl.items?.length || 0;
            for (const item of cl.items || []) {
              if (
                typeof window !== "undefined" &&
                localStorage.getItem(
                  `coachHandbook.progress.${chapter.slug}.${item.key}`
                ) === "1"
              ) {
                done += 1;
              }
            }
            const allDone = total > 0 && done === total;
            return (
              <li key={`${anchor}-${idx}`}>
                <a
                  href={`#${anchor}`}
                  onClick={(e) => handleClick(e, anchor)}
                  className="flex items-center justify-between gap-2 py-1.5 text-sm text-gray-600 hover:text-[#002855] transition-colors"
                >
                  <span className="truncate flex-1">
                    {cl.title || `Checkliste ${idx + 1}`}
                  </span>
                  <span
                    className={`text-xs flex-shrink-0 ${
                      allDone ? "text-[#84BD00]" : "text-gray-400"
                    }`}
                  >
                    {allDone ? <CheckCircle2 className="w-4 h-4" /> : `${done}/${total}`}
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </aside>
  );
};

export default HandbookTOC;
